import { useQueryClient } from '@tanstack/react-query';

import { taskQueries } from '../api/task';
import { StreamCategory } from '../constants/types/stream';
import useStreamChannel from './useStreamChannel';
import useTaskList from './useTaskList';

import type { UseTaskListOptions } from './useTaskList';

/**
 * Task 목록 조회 + SSE 자동 갱신을 묶은 훅 (vpc 등의 `*ListWithSSE` 패턴).
 * @description
 * - `useTaskList`로 목록을 조회하고(자기-조절 폴링 포함), SSE TASK 이벤트 수신 시 list query를 invalidate 한다.
 * - 소비처는 이 훅 하나만 호출하면 목록 구독과 SSE 구독이 함께 유지된다.
 * - 훅이 마운트되어 있는 한, 소비 컴포넌트의 렌더 결과가 `null`이어도 SSE 구독은 끊기지 않는다.
 */
const useTaskListWithSSE = (options: UseTaskListOptions = {}) => {
  const { enabled = true } = options;
  const queryClient = useQueryClient();
  const queryResult = useTaskList(options);

  useStreamChannel({
    onMessageFlush: events => {
      if (!enabled) return;

      const hasTaskEvent = events.some(event => event.category === StreamCategory.TASK);
      if (!hasTaskEvent) return;

      queryClient.invalidateQueries({ queryKey: taskQueries.all() });
    },
  });

  return { ...queryResult };
};

export default useTaskListWithSSE;
